module.exports = __webpack_public_path__ + "_assets/img/error.927de205.svg";